// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/UpSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareOutlinedSvg
  }));
};

UpSquareOutlined.displayName = 'UpSquareOutlined';
export default React.forwardRef(UpSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UpSquareOutlined.js
// module id = 1995
// module chunks = 0